var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTrashCan = function SvgTrashCan(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.2727H25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8407 7H14.1589C13.8334 7 13.5213 7.1293 13.2911 7.35946C13.0609 7.58962 12.9316 7.90178 12.9316 8.22727V10.2727H19.068V8.22727C19.068 7.90178 18.9387 7.58962 18.7085 7.35946C18.4784 7.1293 18.1662 7 17.8407 7Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1592 20.7045V14.5681",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8408 20.7045V14.5681",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6127 23.8709C21.59 24.1784 21.4515 24.4658 21.2253 24.6753C20.9991 24.8848 20.702 25.0008 20.3936 25H11.6064C11.298 25.0008 11.0009 24.8848 10.7747 24.6753C10.5485 24.4658 10.41 24.1784 10.3873 23.8709L9.25 10.2727H22.75L21.6127 23.8709Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTrashCan);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTAuMjcyN0gyNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy44NDA3IDdIMTQuMTU4OUMxMy44MzM0IDcgMTMuNTIxMyA3LjEyOTMgMTMuMjkxMSA3LjM1OTQ2QzEzLjA2MDkgNy41ODk2MiAxMi45MzE2IDcuOTAxNzggMTIuOTMxNiA4LjIyNzI3VjEwLjI3MjdIMTkuMDY4VjguMjI3MjdDMTkuMDY4IDcuOTAxNzggMTguOTM4NyA3LjU4OTYyIDE4LjcwODUgNy4zNTk0NkMxOC40Nzg0IDcuMTI5MyAxOC4xNjYyIDcgMTcuODQwNyA3WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC4xNTkyIDIwLjcwNDVWMTQuNTY4MSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy44NDA4IDIwLjcwNDVWMTQuNTY4MSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMS42MTI3IDIzLjg3MDlDMjEuNTkgMjQuMTc4NCAyMS40NTE1IDI0LjQ2NTggMjEuMjI1MyAyNC42NzUzQzIwLjk5OTEgMjQuODg0OCAyMC43MDIgMjUuMDAwOCAyMC4zOTM2IDI1SDExLjYwNjRDMTEuMjk4IDI1LjAwMDggMTEuMDAwOSAyNC44ODQ4IDEwLjc3NDcgMjQuNjc1M0MxMC41NDg1IDI0LjQ2NTggMTAuNDEgMjQuMTc4NCAxMC4zODczIDIzLjg3MDlMOS4yNSAxMC4yNzI3SDIyLjc1TDIxLjYxMjcgMjMuODcwOVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";